import React, { useEffect, useState } from 'react';

import classes from './KeyBodyMetricsModal.module.scss';
import { LbBigModal } from '../../../../../../shared/components/modals';
import { getScanService } from '../../../../../services/scanService/getScanService';
import { KeyBodyMetricsInfo } from '../../../../../interfaces/keyBodyMetricsInfo';
import { CompareScansTable } from './CompareScansTable/CompareScansTable';
import { EmptyList } from '../../../../../../shared/components/ui-components/EmptyList/EmptyList';
import { CustomerType } from '../../../../../../shared/constants/customer/customerType';

type KeyBodyMetricsModalProps = {
  customerId: number;
  customerType: CustomerType;
  entityId?: number;
  onClose: () => void;
};

const KeyBodyMetricsModal = ({
  customerId,
  customerType,
  entityId,
  onClose,
}: KeyBodyMetricsModalProps) => {
  const [keyBodyMetrics, setKeyBodyMetrics] = useState<KeyBodyMetricsInfo | null>(null);
  const scanService = getScanService(customerType);

  const getKeyBodyMetrics = async () => {
    const info = await scanService.getKeyBodyMetrics(customerId, entityId);

    setKeyBodyMetrics(info);
  };

  useEffect(() => {
    getKeyBodyMetrics();
  }, []);

  if (!keyBodyMetrics) return null;

  const isShowTable = keyBodyMetrics.previous.scanId && keyBodyMetrics.current.scanId;

  return (
    <LbBigModal
      open={!!keyBodyMetrics}
      title="Key Body Metrics"
      buttonOptions={{
        noText: 'Close',
        noHandler: onClose,
        yesVisible: false,
      }}
    >
      {isShowTable ? (
        <div className={classes.box}>
          <CompareScansTable
            compareTitle="Previous"
            compareMetrics={keyBodyMetrics.previous}
            currentMetrics={keyBodyMetrics.current}
          />
          <CompareScansTable
            compareTitle="Initial"
            compareMetrics={keyBodyMetrics.initial}
            currentMetrics={keyBodyMetrics.current}
          />
        </div>
      ) : (
        <EmptyList
          show
          description="User should have at least 2 scans to compare the data"
          size="small"
          className={classes.emptyList}
        />
      )}
    </LbBigModal>
  );
};

export { KeyBodyMetricsModal };
